<template lang="html">
    <modal
            noPadding fullScreen
            :open="open"
            @closeModal="() => open = !open"
    >
        <div v-if="content">
            <ContentRenderer v-for="(section, index) in content" :content="section"/>
        </div>
    </modal>

</template>

<script>
  import { EventBus, EVENTS } from '@/services/events/EventBus'
  import Modal from '@/components/modals/Modal'
  import ModalContentService from '@/services/ModalContentService'
  import ContentRenderer from '@/components/bard-renderer/ContentRenderer'

  export default {
    name: 'ModalRenderer',
    components: {
      Modal,
      ContentRenderer
    },
    data () {
      return {
        open: false,
        content: null
      }
    },
    methods: {
      async openWayfinder (modal) {
        this.open = true
        const response = await ModalContentService.getContent(modal.url.replace('/', ''))
        this.content = response.data.content
      }
    },
    mounted () {
      console.log('Mounted')
      EventBus.$on(EVENTS.OpenModal, this.openWayfinder)
    },
    destroyed () {
      EventBus.$off(EVENTS.OpenModal, this.openWayfinder)
    }
  }
</script>

<style lang="scss" scoped>

</style>
